import { Header } from '@cloudscape-design/components';
import { WidgetConfig } from '../interfaces';
import ContactTraceRecord from './contactTraceRecord';
import { ContactTraceRecordWidgetContext, Provider } from './provider';
import { useContext } from 'react';

export const getContactTraceRecord: WidgetConfig = {
  definition: { defaultRowSpan: 1, defaultColumnSpan: 2, minRowSpan: 1 },
  data: {
    icon: 'table',
    title: 'Agent metrics',
    description: 'Realtime agent data. Table for all agents',
    header: ChartHeader,
    content: ContactTraceRecord,
    provider: Provider,
    staticMinHeight: 560,
    multipleAllowed: true,
  },
};

function ChartHeader() {
      const { agentCount } = useContext(ContactTraceRecordWidgetContext);
  
  return (
    <Header variant="h2">
      Realtime agents {agentCount ? `(${agentCount})` : ''}
    </Header>
  );
}
